// extracted by mini-css-extract-plugin
export var root = "MarkdownOL-module--root--75052";